import { BringzzIcon } from "@bringzz/components";

const LoadingSpinner = () => {
    return (
        <div className="relative w-full h-[calc(100vh-64px)] overflow-hidden">
            <div className="flex justify-center items-center h-full">
                <BringzzIcon
                    icon="IconSpinner"
                    folder="LineIcons"
                    size="32"
                    className="animate-spin"
                />
            </div>
        </div>
    );
};

export default LoadingSpinner; 